module.exports = __webpack_public_path__ + "static/media/12.e5befde2.jpg";